import React from 'react';
import { motion } from 'framer-motion';
import Dashboard from './Dashboard';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Header = ({ user, subscription, profile }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center space-y-4"
    >
      <div className="flex items-center justify-center gap-3">
        <SafeIcon icon={FiIcons.FiTarget} className="w-8 h-8 text-blue-400" />
        <h1 className="text-4xl font-bold text-white">Sneaky Redirects</h1>
        <SafeIcon icon={FiIcons.FiTarget} className="w-8 h-8 text-blue-400" />
      </div>
      
      <p className="text-slate-400 text-lg max-w-2xl mx-auto">
        Create encrypted JavaScript redirect scripts with enhanced security
      </p>

      {user && subscription && <Dashboard user={user} subscription={subscription} profile={profile} />}
    </motion.div>
  );
};

export default Header;